import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import humanTime from 'flarum/common/helpers/humanTime';
import extractText from 'flarum/common/utils/extractText';
const t = (key, params) => app.translator.trans('ernestdefoe-flarumverse.forum.page.' + key, params);
/** /flarumverse: the newest discussions from paired forums, newest first. */
export default class FlarumversePage extends Page {
  threads = [];
  partners = [];
  partner = '0';
  more = false;
  loading = true;
  /** Partners whose favicon didn't load: they show their initial instead. */
  broken = new Set();
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('flarumverse', extractText(t('title')));
    app.setTitle(extractText(t('title')));
    this.load(true);
  }
  load(reset) {
    this.loading = true;
    const offset = reset ? 0 : this.threads.length;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/flarumverse/threads',
      params: {
        partner: this.partner,
        offset
      }
    }).then(res => {
      this.threads = reset ? res.threads : this.threads.concat(res.threads);
      this.partners = res.partners;
      this.more = res.more;
      this.loading = false;
      m.redraw();
    }, () => {
      this.loading = false;
      m.redraw();
    });
  }

  /** A forum's accent: its own brand colour, else a hue picked from its id so it keeps one. */
  static accent(id, color) {
    return color && /^#[0-9a-f]{6}$/i.test(color) ? color : `hsl(${id * 137 % 360}, 58%, 46%)`;
  }
  static host(url) {
    try {
      return url ? new URL(url).host.replace(/^www\./, '') : '';
    } catch (e) {
      return '';
    }
  }
  chip(id, label, accent) {
    const active = this.partner === id;
    return m("button", {
      type: "button",
      className: 'FlarumverseChip' + (active ? ' FlarumverseChip--active' : ''),
      "aria-pressed": active,
      style: accent ? {
        '--fv-accent': accent
      } : undefined,
      onclick: () => {
        if (active) return;
        this.partner = id;
        this.load(true);
      }
    }, accent ? m("span", {
      className: "FlarumverseChip-dot"
    }) : null, label);
  }
  view() {
    const partners = new Map(this.partners.map(p => [p.id, p]));
    return m(PageStructure, {
      className: "FlarumversePage",
      sidebar: () => m(IndexSidebar, null)
    }, m("header", {
      className: "FlarumverseHero"
    }, m("span", {
      className: "FlarumverseHero-icon",
      "aria-hidden": "true"
    }, m(Icon, {
      name: "fas fa-satellite-dish"
    })), m("div", {
      className: "FlarumverseHero-text"
    }, m("h2", {
      className: "FlarumverseHero-title"
    }, t('title')), m("p", {
      className: "FlarumverseHero-intro"
    }, t('intro', {
      forum: app.forum.attribute('title')
    })))), this.partners.length > 1 ? m("div", {
      className: "FlarumverseChips",
      role: "group",
      "aria-label": extractText(t('filter'))
    }, this.chip('0', t('all_forums')), this.partners.map(p => this.chip(String(p.id), p.name, FlarumversePage.accent(p.id, p.color)))) : null, this.threads.length === 0 && !this.loading ? m(Placeholder, {
      text: t('empty')
    }) : null, m("ul", {
      className: "FlarumverseList"
    }, this.threads.map(thread => {
      const partner = partners.get(thread.partner);
      const host = FlarumversePage.host(partner?.url || thread.url);
      const name = thread.forum || host;
      return m("li", {
        key: thread.id,
        className: "FlarumverseItem",
        style: {
          '--fv-accent': FlarumversePage.accent(thread.partner, partner?.color)
        }
      }, m("a", {
        className: "FlarumverseItem-link",
        href: thread.url,
        rel: "noopener ugc"
      }, m("span", {
        className: 'FlarumverseItem-avatar' + (partner?.icon && !this.broken.has(thread.partner) ? ' FlarumverseItem-avatar--icon' : ''),
        "aria-hidden": "true"
      }, partner?.icon && !this.broken.has(thread.partner) ? m("img", {
        src: partner.icon,
        alt: "",
        loading: "lazy",
        decoding: "async",
        referrerpolicy: "no-referrer",
        onerror: () => this.broken.add(thread.partner)
      }) : (name || '?').trim().charAt(0).toUpperCase()), m("span", {
        className: "FlarumverseItem-body"
      }, m("span", {
        className: "FlarumverseItem-source"
      }, m("span", {
        className: "FlarumverseItem-forum"
      }, name), host && host !== name ? m("span", {
        className: "FlarumverseItem-host"
      }, host) : null, m("span", {
        className: "FlarumverseItem-time"
      }, humanTime(new Date(thread.postedAt)))), m("span", {
        className: "FlarumverseItem-title"
      }, thread.title), thread.excerpt ? m("span", {
        className: "FlarumverseItem-excerpt"
      }, thread.excerpt) : null, m("span", {
        className: "FlarumverseItem-meta"
      }, thread.author ? m("span", {
        className: "FlarumverseItem-pill"
      }, m(Icon, {
        name: "far fa-user"
      }), " ", thread.author) : null, thread.tag ? m("span", {
        className: "FlarumverseItem-pill"
      }, m(Icon, {
        name: "fas fa-tag"
      }), " ", thread.tag) : null, m("span", {
        className: "FlarumverseItem-pill"
      }, m(Icon, {
        name: "far fa-comment"
      }), " ", t('replies', {
        count: thread.replies
      })), m("span", {
        className: "FlarumverseItem-open"
      }, t('open_on', {
        forum: name
      }), " ", m(Icon, {
        name: "fas fa-arrow-up-right-from-square"
      }))))));
    })), this.loading ? m(LoadingIndicator, null) : null, this.more && !this.loading ? m("div", {
      className: "FlarumversePage-more"
    }, m(Button, {
      className: "Button",
      onclick: () => this.load(false)
    }, t('load_more'))) : null);
  }
}